import React, { useRef, useEffect } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { Popover } from '@fiverr-private/fit';
import { useLoadOfferMoreGigs } from '../../../hooks/useLoadOfferMoreGigs';
import EmptyComponent from './EmptyComponent';
import ContactSellerPopoverContent from './ContactSellerPopoverContent';

import classes from './style.module.scss';

export const ContactSellerPopover = ({
    onClose = noop,
    onOpen = noop,
    className,
    onStepChange = noop,
    onSubmit,
    onFailure,
    isSent,
    isOpen,
    isNight,
    onCloseButtonClick,
    showConfirmationModal,
    onCloseConfirmationModal
}) => {
    const ref = useRef(null);

    useLoadOfferMoreGigs(isOpen);

    useEffect(() => {
        isOpen ? openPopover() : closePopover();
    }, [isOpen]);

    const closePopover = () => {
        ref.current && ref.current.close();
    };

    const openPopover = () => {
        ref.current && ref.current.open();
    };

    const contentProps = {
        isOpen,
        onClose,
        onFailure,
        onSubmit,
        onStepChange,
        onCloseButtonClick,
        onCloseConfirmationModal,
        showConfirmationModal,
        isNight,
        isSent
    };

    return (
        <Popover ref={ref} className={className}
            allowOverflow
            onOpen={onOpen}
            appendToBody={false}
            shouldPreventCloseAction={() => true}
            position={Popover.POSITIONS.TOP_LEFT}
            boxClassName={classes.popoverBox}
            content={<ContactSellerPopoverContent {...contentProps}/>}>
            <EmptyComponent/>
        </Popover>
    );
};

ContactSellerPopover.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    className: PropTypes.string,
    onSubmit: PropTypes.func,
    onStepChange: PropTypes.func,
    onFailure: PropTypes.func,
    isSent: PropTypes.bool,
    isNight: PropTypes.bool,
    onCloseButtonClick: PropTypes.func,
    showConfirmationModal: PropTypes.bool,
    onCloseConfirmationModal: PropTypes.func
};
